import { Card, Col, Row } from 'antd';
import {
  AlertOutlined, ContactsOutlined, GiftOutlined, MessageOutlined, UserOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router';
import type { DashboardSummary } from '@/api/dashboard';
import {
  DashboardHeader, KpiGrid, RecentNoticesCard, type KpiSpec,
} from './shared';

/**
 * Admin / Front Desk dashboard — visitors, inquiries, complaints, notices,
 * and the holiday calendar (gained in V11). No money, no academics.
 */
export function FrontDeskDashboard({ data }: { data: DashboardSummary }) {
  const kpis: KpiSpec[] = [
    {
      key: 'visitors',
      label: 'Visitors today',
      value: data.frontDesk.visitorsToday,
      hint: 'Walk-ins logged at reception',
      icon: <UserOutlined />,
      tone: 'primary',
    },
    {
      key: 'inquiries',
      label: 'Inquiries this month',
      value: data.frontDesk.inquiriesThisMonth,
      hint: 'New parents asking about admission',
      icon: <ContactsOutlined />,
      tone: 'info',
    },
    {
      key: 'complaints',
      label: 'Open complaints',
      value: data.frontDesk.openComplaints,
      hint: 'Awaiting resolution',
      icon: <AlertOutlined />,
      tone: 'warning',
    },
  ];

  return (
    <div style={{ display: 'grid', gap: 20 }}>
      <DashboardHeader role={data.role} asOf={data.asOf} title="Reception" />
      <KpiGrid kpis={kpis} />

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card title="Today" size="small">
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2 }}>
              <li><Link to="/frontdesk/visitors"><UserOutlined /> Log a visitor</Link></li>
              <li><Link to="/frontdesk/inquiries"><ContactsOutlined /> Capture an inquiry</Link></li>
              <li><Link to="/frontdesk/complaints"><AlertOutlined /> Open complaints</Link></li>
              <li><Link to="/frontdesk/notices"><MessageOutlined /> Post a notice</Link></li>
            </ul>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title="School calendar" size="small">
            <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 2 }}>
              <li><Link to="/attendance/holidays"><GiftOutlined /> Manage holidays</Link></li>
              <li><Link to="/frontdesk/issuances">Issue a document</Link></li>
              <li><Link to="/students">Look up a student</Link></li>
            </ul>
          </Card>
        </Col>
      </Row>

      <RecentNoticesCard notices={data.recentNotices} />
    </div>
  );
}
